import React from 'react'
import {
  ContentBlock,
  ContentState,
  EditorProps,
  CompositeDecorator,
  SelectionState,
} from 'draft-js'
import { List } from 'immutable'

export interface CustomBlockComponentProps<BlockProps> {
  block: ContentBlock
  blockProps: BlockProps
  blockStyleFn: EditorProps['blockStyleFn']
  contentState: ContentState
  customStyleFn: EditorProps['customStyleFn']
  customStyleMap: EditorProps['customStyleMap']
  decorator?: CompositeDecorator
  direction: 'LTR' | 'RTL'
  forceSelection: boolean
  offsetKey: string
  selection: SelectionState
  startIndent?: boolean
  tree: List<unknown>
}

export interface CustomBlockRendererConfig {
  component: React.ReactNode
  editable?: boolean
  props?: unknown
}
